import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

export default class BookingSummary {
    waiting: number;
    done: number;
    canceled: number;
    received: number;
    expected: number;
    // Time fields (SUM of `duration` in MINUTES). Present on the extended
    // `summary` endpoint; optional so older consumers keep compiling.
    hoursReceived?: number;
    hoursExpected?: number;
    hoursBlocked?: number;

    constructor(
        waiting: number,
        done: number,
        canceled: number,
        received: number,
        expected: number,
        hoursReceived?: number,
        hoursExpected?: number,
        hoursBlocked?: number
    ) {
        this.waiting = waiting;
        this.done = done;
        this.canceled = canceled;
        this.received = received;
        this.expected = expected;
        this.hoursReceived = hoursReceived;
        this.hoursExpected = hoursExpected;
        this.hoursBlocked = hoursBlocked;
    }

    public static readonly info = async (
        uuid: string,
        brand: string,
        location: string,
        year: number,
        month: number,
        day?: number
    ) =>
        (await axios
            .get(
                environment.api_url +
                    "/" +
                    brand +
                    "/location/" +
                    location +
                    "/booking/summary/" +
                    year +
                    "/" +
                    month +
                    (day !== undefined ? "/" + day : ""),
                {
                    headers: {
                        "User-Token": uuid,
                    },
                }
            )
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as BookingSummary | undefined;
}
